<!-- 分页组件封装 -->
<template>
  <div class="self-pagination rc-page">
    <el-pagination
      background
      :current-page.sync="pagination.pageNum"
      :page-size.sync="pagination.pageSize"
      :total="pagination.total"
      layout="total, prev, pager, next, slot"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <template v-if="lang === 'zh'">
        <div class="pagination-jumper">
          跳转
          <input
            v-model="pagination.curPage"
            type="number"
            @input="onInput"
            @keyup.enter="handleCurrentChange"
          />
          页，
        </div>
        <div class="pagination-sizes">
          显示
          <el-select
            v-model="pagination.pageSize"
            class="pagination-select"
            placeholder=""
            @change="handleSizeChange"
          >
            <el-option
              v-for="item in sizes"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          条
        </div>
      </template>
      <template v-else>
        <div class="pagination-jumper">
          Go to page
          <input
            v-model="pagination.curPage"
            type="number"
            @input="onInput"
            @keyup.enter="handleCurrentChange"
          />
        </div>
        <div class="pagination-sizes">
          Display
          <el-select
            v-model="pagination.pageSize"
            class="pagination-select"
            placeholder=""
            @change="handleSizeChange"
          >
            <el-option
              v-for="item in sizes"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          result(s) / page
        </div>
      </template>
    </el-pagination>
  </div>
</template>

<script>
import { defaultSizes } from "@/utils/settings";
import { getLang } from "@/utils/auth";
export default {
  name: "RcPagination",
  props: {
    sizes: {
      type: Array,
      // 10, 20, 50, 100
      default: () => defaultSizes
    },
    pageInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pagination: {
        pageNum: 1,
        pageSize: 10,
        curPage: 0,
        total: 0
      }
    };
  },
  computed: {
    lang() {
      return getLang("lang");
    }
  },
  watch: {
    pageInfo: {
      handler(val) {
        this.$set(this, "pagination", val);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    setPageNum() {
      const { total, pageSize } = this.pagination;
      this.pagination.pageNum = Math.ceil(total / pageSize);
    },
    // 判断是否超过最大页数
    checkIfOverPage() {
      const { pageNum, pageSize, total } = this.pagination;
      return pageNum > Math.ceil(total / pageSize);
    },
    handleSizeChange(val) {
      const ifOverPage = this.checkIfOverPage();
      if (ifOverPage) {
        this.setPageNum();
        this.pagination.curPage = this.pagination.pageNum;
      }
      this.$emit("size-change", this.pagination);
    },
    handleCurrentChange(val) {
      // if是由1,2,3页和上一页下一页触发的
      if (typeof val === "number") {
        this.$set(this.pagination, "pageNum", val);
      } else {
        // 预先处理跳转页超过最大页数的情况
        const ifOverPage = this.checkIfOverPage();
        const { curPage, pageNum } = this.pagination;
        if (ifOverPage) {
          this.setPageNum();
          this.pagination.curPage = pageNum;
        } else {
          this.pagination.pageNum = Number(curPage);
        }
      }
      this.$emit("current-change", this.pagination);
    },
    onInput() {
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
